import { connect } from 'react-redux'
import School from './school'
import { getUser } from '../../../../stores/user/user.selectors'

const mapStateToProps = state => {
  const user = getUser(state)
  return {
    inSchool: user.teacher_type && user.teacher_type.school
  }
}

export default connect(
  mapStateToProps,
  null
)(School)
